export default __webpack_public_path__ + "static/media/330_private01-fr-web.b823f47c.png";